
import Loader from "react-loader-spinner";
import { faListOl, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useReducer, useRef, useState } from "react";
import { Alert, Button, Col, Form, FormGroup, Modal, Row } from "react-bootstrap";
import { getBaseInfoList, getInfoTypeList, addBaseInfo, editBaseInfo } from "../store/api/BaseInfoApi";
import BihamtaTable from "../../Components/BihamtaTable";
import { CheckLg, DashCircle, ExclamationTriangle, PlusSquareFill } from "react-bootstrap-icons";

const ModalBaseInfo = (props) => {
    const { popData, setPopData } = props;
    const { show } = popData;
    const typeID = useRef(null);
    const [error, setError] = useState(null);
    const [infoTypes, setInfoTypes] = useState({ Data: [] });
    const [bInfoes, setBInfoes] = useState({ Data: [] });
    const [currentB, setCurrentB] = useState(null);
    function close() {
        setPopData({
            show: false
        })
        setCurrentB(null);
        setBInfoes({ Data: [] });
    }
    function getBInfoList(e) {
        typeID.current = e.target.value;
        getBaseInfoList(typeID.current, setBInfoes);
    }
    function prepareForAdd() {
        if (!typeID) {
            setError("نوع اطلاعات وارد نشده است");
            return;
        }
        let code = 0;
        if (bInfoes.Data && Array.isArray(bInfoes.Data) && bInfoes.Data.length > 0) {
            code = Math.max(...bInfoes.Data.map(o => o.Code));
        }
        setCurrentB({ ID: 0, TypeID: typeID.current, Code: code + 1 });
    }
    function cancel() {
        setError(null);
        setCurrentB(null);
    }
    function prepareForEdit(row) {
        const { e, target, ...bInfo } = row;
        setCurrentB(bInfo);
    }
    function onSubmit() {
        setError(null);
        if ((currentB?.InfoName ?? "") === "") {
            setError("شرح اطلاعات وارد نشده است");
            return;
        }
        const onSuccess = (res) => {
            if (res.Error) {
                setError(res.Error);
            }
            else if (res.Data) {
                if (Number(currentB.ID) === 0) {
                    currentB.ID = Number(res.Data);
                    bInfoes.Data.push(currentB);
                    setBInfoes({ ...bInfoes });
                }
                else {
                    bInfoes.Data.find(b => Number(b.ID) === Number(currentB.ID)).InfoName = currentB.InfoName;
                    setBInfoes({ ...bInfoes });
                }
                setCurrentB(null);
            }
        }
        if (Number(currentB.ID) === 0) {
            addBaseInfo(currentB, onSuccess);
        }
        else {
            editBaseInfo(currentB.ID, currentB.InfoName, onSuccess);
        }

    }
    const tableCols = [
        { colTitle: "کد اطلاعات", colName: "Code", showInMobile: true },
        { colTitle: "شرح اطلاعات", colName: "InfoName", showInMobile: true }
    ]
    useEffect(() => {
        if (show) {
            if (!infoTypes?.Data || infoTypes.Data.length === 0) {
                getInfoTypeList(setInfoTypes);
            }
        }
    }, [show])
    return (
        <Modal show={show} onHide={() => { }}>
            <Modal.Header className="headerStyle">
                <span>
                    <FontAwesomeIcon icon={faListOl} size="lg" />&nbsp;
                    مدیریت اطلاعات پایه
                </span>
                <FontAwesomeIcon icon={faTimes} size="lg" onClick={close} />
            </Modal.Header>
            <Modal.Body className="bodyStyle" style={{ paddingTop: "0px" }}>
                <FormGroup>
                    {
                        infoTypes === "PENDING" &&
                        <div className="form-control" style={{ textAlign: "center" }}>
                            <Loader type="BallTriangle" color="#bb1370" width={20} height={20} />
                        </div>
                    }
                    {infoTypes?.Data &&
                        <select className="form-control" onChange={getBInfoList}>
                            <option value="">نوع اطلاعات را انتخاب کنید</option>
                            {Array.isArray(infoTypes.Data) && infoTypes.Data.map((item, i) => <option value={item.ID} key={i}>{item.Name}</option>)}
                        </select>
                    }
                </FormGroup>
                {error &&
                    <Alert variant="danger"><ExclamationTriangle size={18} />&nbsp; {error}
                        <FontAwesomeIcon icon={faTimes} size="lg" onClick={() => { setError(null) }} style={{ float: "left" }} />
                    </Alert>
                }
                {currentB &&
                    <Row className="rowBorder mt-2">
                        <Col md={4} className="form-group">
                            <label>کد اطلاعات: </label>
                            <Form.Control defaultValue={currentB.Code ?? ""} readOnly />
                        </Col>
                        <Col md={8} className="form-group">
                            <label>شرح اطلاعات: </label>
                            <Form.Control defaultValue={currentB.InfoName ?? ""} onChange={e => currentB.InfoName = e.target.value} />
                        </Col>
                        <Col className="mt-2">
                            <Button className="group-Btn" variant="info" onClick={onSubmit}><CheckLg />&nbsp; ثبت اطلاعات</Button>
                            <Button className="group-Btn" variant="danger" onClick={cancel}><DashCircle />&nbsp;انصراف</Button>
                        </Col>
                    </Row>
                }
                {!currentB && <PlusSquareFill color="#4c4cad" size={23} className="hoverIcon mt-2" onClick={prepareForAdd} />}
                <div className="scThin mt-2" style={{ maxHeight: "350px", overflow: "auto" }}>
                    <BihamtaTable columns={tableCols} dataList={bInfoes} className="mt-0 mb-0" rowClick={prepareForEdit} />
                </div>
            </Modal.Body>
        </Modal>
    )


}
export default ModalBaseInfo;